import Link from 'next/link'

import clsx from 'clsx'

import { usePortal } from '@/hooks/support/usePortal'

import Icon from '@/components/Icon'
import RowSkeleton from '@/components/skeletons/RowSkeleton'

const SupportTopic = () => {
  const { articles, isLoading } = usePortal()

  const { topics } = articles || {}

  return (
    <div className="grid grid-cols-1 gap-3 tablet:grid-cols-3 tablet:gap-y-2 desktop:grid-cols-3 desktop:gap-5">
      {isLoading ? (
        <>
          {[...Array(3)].map((_, index) => (
            <RowSkeleton
              className="mb-5 h-[148px] w-full last:mb-0"
              key={index}
            />
          ))}
        </>
      ) : (
        topics?.map(({ title, icon, id, slug }, index) => (
          <Link
            className={clsx(
              'flex items-center gap-3 rounded-xl border-[0.5px] border-slate-300 p-3',
              'transition-colors hover:border-primary-600 tablet:min-h-[148px]',
              'tablet:flex-col tablet:items-start tablet:gap-5 tablet:p-5'
            )}
            key={index}
            href={{
              pathname: '/support/[id]/[slug]',
              query: { id, slug }
            }}
          >
            <Icon
              className="h-6 w-6 flex-none text-secondary-500"
              name={icon ? icon : 'search-24'}
            />
            <div
              className={clsx(
                'mr-auto text-x-base font-medium leading-x-base',
                'tablet:mt-auto tablet:min-h-11 tablet:text-x-md tablet:leading-x-md'
              )}
            >
              {title}
            </div>
            <Icon
              className="h-4 w-4 flex-none text-secondary-500 tablet:hidden"
              name="chevron-right-16"
            />
          </Link>
        ))
      )}
    </div>
  )
}

export default SupportTopic
